export enum SeasonItem {
  tvShow = 'tvShow',
  Soundtrack = 'soundtrack',
}

export enum DetailType {
  Show = 'ShowDetail',
  Movie = 'MovieDetail',
}
